module.exports = __webpack_public_path__ + "static/media/GenAI_Cohort.16dafb0c.png";